<p-toast [baseZIndex]="9999" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="form-row">
        <div class="col-md-8">
          <lib-page-header page-title="CONTRATOS E ADITIVOS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/contrato.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/contratos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="verificarMudancaAudesp()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="#dados-contrato-tab" role="tab" data-toggle="tab">Dados do contrato</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#adiantamento-tab" role="tab" data-toggle="tab">Aditamentos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#reajuste-tab" role="tab" data-toggle="tab">Ajustes</a>
        </li>
        <li class="nav-item" *ngIf="entidade.favorecido">
          <a class="nav-link" href="#responsavel-tab" role="tab" data-toggle="tab">Responsáveis</a>
        </li>
        <li *ngIf="entidade.id" class="nav-item">
          <a class="nav-link" href="#historico-tab" role="tab" data-toggle="tab">Históricos</a>
        </li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane active" id="dados-contrato-tab">
          <br />

          <div class="row">
            <div class="col-md-9">
              <div class="form-row">
                <div class="col-md-4 form-group form-group-sm">
                  <label for="numero" class="required">Nº Contrato / Ano</label>
                  <input id="numero" formControlName="numero" type="text" [unmask]="true"
                    [imask]="{mask: [ {mask: '0000/0000'}, {mask: '00000/0000'} ]}"
                    class="form-control font-weight-bold col-md-8 pr-0 float-left">
                  <input unmask="typed" [imask]="imaskQtd" formControlName="ano" type="text"
                    class="form-control text-right col-md-4 pl-0" id="ano">
                </div>
                <div class="col-md-2 form-group form-group-sm">
                  <label for="data_assinatura" class="required">Assinatura</label>
                  <p-calendar id="data_assinatura" formControlName="data_assinatura" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
                  </p-calendar>
                </div>
                <div class="col-md-2 form-group form-group-sm">
                  <label for="data_inicio" class="required">Início</label>
                  <p-calendar id="data_inicio" formControlName="data_inicio" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
                  </p-calendar>
                </div>
                <div class="col-md-2 form-group form-group-sm">
                  <label for="data_termino" class="required">Término</label>
                  <p-calendar id="data_termino" formControlName="data_termino" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
                  </p-calendar>
                </div>
                <div class="col-md-2 form-group form-group-sm">
                  <label for="data_contabilizacao" class="required">Contabilização</label>
                  <p-calendar id="data_contabilizacao" formControlName="data_contabilizacao"
                    inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                    [showButtonBar]="true" [showIcon]="true">
                  </p-calendar>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12 form-group">
                  <label for="favorecido" class="required">Beneficiário</label>
                  <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                    (onSelect)="favorecidoAutoComplete.atualizar(false)" [suggestions]="favorecidoAutoComplete.lista"
                    (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                    inputStyleClass="form-control font-weight-bold" minLength="3" [style]="{ width: '100%' }"
                    [forceSelection]="true" [autoHighlight]="true" *ngIf="favorecidoAutoComplete">
                    <ng-template let-favorecido pTemplate="item">
                      {{favorecido.cpf_cnpj | CPF}} - {{favorecido.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-4 form-group form-group-sm">
                  <label for="licitacao">Licitação</label>
                  <p-autoComplete formControlName="licitacao" [field]="licitacaoAutoComplete.conversor"
                    (onSelect)="licitacaoAutoComplete.atualizar(false)" [suggestions]="licitacaoAutoComplete.lista"
                    (completeMethod)="licitacaoAutoComplete.filtrar($event)" inputStyleClass="form-control"
                    minLength="3" [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    *ngIf="licitacaoAutoComplete">
                    <ng-template let-licitacao pTemplate="item">
                      {{licitacao.numero | LICITACAO}} - {{licitacao.modalidade?.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>

                <div class="col-md-4 form-group form-group-sm">
                  <label for="processo" class="required">Processo</label>
                  <input id="processo" formControlName="processo" type="text" [unmask]="false"
                    [imask]="{mask: '0000/0000'}" class="form-control">
                </div>

                <div class="col-md-4 form-group form-group-sm">
                  <label for="prazo" class="required">Prazo</label>
                  <select [compareWith]="compareFn" id="prazo" formControlName="prazo" class="custom-select">
                    <option [ngValue]="item" *ngFor="let item of listaPrazos">{{item.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-8 form-group form-group-sm">
                  <label for="tipo_contratacao" class="required">Contratação</label>
                  <select [compareWith]="compareFn" id="tipo_contratacao" formControlName="tipo_contratacao"
                    class="custom-select" (blur)="tipoContratacao()">
                    <option [ngValue]="item" *ngFor="let item of listaContratacao">
                      {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 form-group form-group-sm">
                  <label for="tipo_contrato" class="required">Tipo de Contrato</label>
                  <select [compareWith]="compareFn" id="tipo_contrato" formControlName="tipo_contrato"
                    class="custom-select">
                    <option [value]="item.id" *ngFor="let item of listaTipos">
                      {{item.nome}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-2 form-group form-group-sm">
                  <label for="valor_contrato" class="required">Valor Contrato</label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_contrato" type="text"
                    class="form-control text-right font-weight-bold text-primary" id="valor_contrato"
                    placeholder="0,00">
                </div>
                <div class="col-md-2 form-group form-group-sm"
                  *ngIf="entidadeForm.get('tipo_contratacao').value && entidadeForm.get('tipo_contratacao').value.servico && entidadeForm.get('tipo_contratacao').value.material">
                  <label for="valor_material" class="required">Valor Material</label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_material" type="text"
                    class="form-control text-right font-weight-bold text-primary" id="valor_material"
                    placeholder="0,00">
                </div>
                <div class="col-md-2 form-group form-group-sm"
                  *ngIf="entidadeForm.get('tipo_contratacao').value && entidadeForm.get('tipo_contratacao').value.servico && entidadeForm.get('tipo_contratacao').value.material">
                  <label for="valor_servico" class="required">Valor Serviço</label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_servico" type="text"
                    class="form-control text-right font-weight-bold text-primary" id="valor_servico" placeholder="0,00">
                </div>
                <div class="col-md-2 form-group form-group-sm">
                  <label for="valor_garantia"> Valor Garantia</label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_garantia" type="text"
                    class="form-control text-right" id="valor_garantia" placeholder="0,00">
                </div>
                <div class="col-md-2 form-group form-group-sm">
                  <label for="valor_caucao">Valor Caução</label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_caucao" type="text"
                    class="form-control text-right" id="valor_caucao" placeholder="0,00">
                </div>
              </div>

              <div class="form-row">
                <div class="col-12">
                  <label for="objeto" class="required">Objeto do Contrato</label>
                  <textarea formControlName="objeto" class="form-control" id="objeto" rows="5"></textarea>
                </div>
              </div>

              <div class="form-row pt-3">
                <div class="col-md-12 form-group form-group-sm">
                  <div class="checkbox checbox-switch switch-success">
                    <label>
                      <input formControlName="gestor_exige" type="checkbox" />
                      <span></span>
                      Existe gestor do contrato
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-row pt-1">
                <div class="col-12">
                  <p-panel *ngIf="entidadeForm.get('gestor_exige').value" [toggleable]="true" collapseIcon="fa fa-eye"
                    expandIcon="fa fa-eye-slash">
                    <ng-template pTemplate="header">
                      <div>
                        <em class="fa fa-user-tie mr-1"></em>
                        Gestor do contrato
                      </div>
                    </ng-template>
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label for="cpf">CPF<span class="text-danger">*</span></label>
                        <p-inputMask id="cpf" formControlName="gestor_cpf" mask="999.999.999-99" unmask="true"
                          slotChar=" " styleClass="form-control">
                        </p-inputMask>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-8">
                        <label for="gestor">Gestor<span class="text-danger">*</span></label>
                        <input id="gestor" type="text" formControlName="gestor" class="form-control" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-8">
                        <label for="gestor_cargo">Cargo<span class="text-danger">*</span></label>
                        <input id="gestor_cargo" type="text" formControlName="gestor_cargo" class="form-control" />
                      </div>
                    </div>
                  </p-panel>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-row pt-3">
                <div class="col-md-12 form-group form-group-sm">
                  <p-radioButton name="tipo" value="CONTRATO" formControlName="tipo" label="Contrato"
                    inputId="CONTRATO"></p-radioButton>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12 form-group form-group-sm">
                  <p-radioButton name="tipo" value="REGISTRO_PRECO" formControlName="tipo" label="Registro de Preço"
                    inputId="REGISTRO_PRECO"></p-radioButton>
                </div>
              </div>
              <hr>
              <div class="form-row pt-2">
                <div class="col-md-12 form-group form-group-sm">
                  <div class="checkbox checbox-switch switch-success">
                    <label>
                      <input formControlName="enviar_email" type="checkbox" />
                      <span></span>
                      Enviar e-mail
                    </label>
                  </div>
                </div>
                <div class="col-12">
                  <lib-licitacao-audesp-menu *ngIf="entidade?.id" [entidade]="entidade?.licitacao_audesp">
                  </lib-licitacao-audesp-menu>
                </div>
              </div>
            </div>
          </div>

          <br>
          <button [disabled]="!entidadeForm.valid && entidadeForm.get('id').value" data-toggle="modal"
            data-target="#dialogUpload" type="button" class="btn btn-sm btn-outline-primary">
            Anexar arquivo e enviar
          </button>
          <div class="row mt-2" *ngIf="listaAnexos.length">
            <div class="col-12">
              <table class="table table-eddy">
                <thead>
                  <tr style="height: 42px;">
                    <th scope="col" class="text-left">Descrição</th>
                    <th scope="col" class="text-left">Nome do arquivo</th>
                    <th scope="col" class="text-left">Tipo</th>
                    <th scope="col" class="text-left">Tamanho</th>
                    <th scope="col" class="text-center">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of listaAnexos">
                    <td style="width: 50%;" class="text-left">{{item.descricao}}</td>
                    <td style="width: 50%;" class="text-left">{{item.nome}}</td>
                    <td style="width: 30%;" class="text-left">{{item.tipo}}
                    <td style="width: 110px;" class="text-left">{{item.tamanho}}</td>
                    <td style="width: 110px;" class="text-center">
                      <a href="javascript:void" (click)="download(item)">
                        <img src="assets/img/global/download_cloud.png" alt="cvs" title="download" height="22"
                          width="22">
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="adiantamento-tab">
          <lib-contrato-aditamento [(lista)]="listaAditamentos" [login]="login" [(contrato)]="entidade">
          </lib-contrato-aditamento>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="reajuste-tab">
          <lib-contrato-reajuste [(lista)]="listaReajustes" [login]="login" [(contrato)]="entidade">
          </lib-contrato-reajuste>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="responsavel-tab" *ngIf="entidade.favorecido">
          <lib-contrato-responsavel [lista]="listaResponsaveis" [login]="login" [favorecido]="entidade.favorecido.id">
          </lib-contrato-responsavel>
        </div>
        <div *ngIf="entidade.id" role="tabpanel" class="tab-pane fade" id="historico-tab">
          <lib-contrato-historico [(lista)]="listaHistoricos" [login]="login" [(listaContratacao)]="listaContratacao"
            [(contrato)]="entidade">
          </lib-contrato-historico>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="verificarMudancaAudesp(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal fade" id="dialogUpload" tabindex="-1" role="dialog" aria-labelledby="uploadArquivo"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Enviar arquivo e salvar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <div class="col-md-12">
            <label for="descricao">Descrição<span class="text-danger">*</span></label>
            <input class="form-control font-weight-bold" type="text" [(ngModel)]="descricao" />
          </div>
        </div>
        <br />
        <div class="form-row">
          <div class="col-md-12">
            <form enctype="multipart/form-data">
              <p-fileUpload #fileUpload customUpload=true (uploadHandler)="onUpload($event, fileUpload)"
                chooseLabel="Selecionar" uploadLabel="Enviar" cancelLabel="Cancelar" multiple="multiple"
                accept=".pdf,.csv,.xml,.png,.xls,.xlsx,.odt" maxFileSize="1000000000">
                <ng-template pTemplate="content">
                  <ul *ngIf="uploadedFiles.length">
                    <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                  </ul>
                </ng-template>
              </p-fileUpload>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button #btnCancelarUpload type="button" class="btn btn-secondary" id="btnCancelarUpload"
          data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Ateração de contrato" [(visible)]="displayHistorico" [style]="{width: '50vw', height: '40vw'}"
  [modal]="true">
  <div class="form-row">
    <div class="col-md-12 form-group">
      <label for="data_contabil" class="required">Data de envio</label>
      <p-calendar id="data_contabil" [(ngModel)]="dataContabil" inputStyleClass="form-control" dataType="date"
        dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
      </p-calendar>
    </div>
  </div>
  <div class="form-row">
    <div class="col-md-12 form-group">
      <span class="font-weight-lighter">Houve mudanças em campos que são envidados para o TCE, informe a data que você
        deseja transmitir essas alterações.</span>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" pButton (click)="confirmaHistorico()">OK</button>
  </ng-template>
</p-dialog>